import { z } from "zod";
import { DocumentationItemConfigurationV2 } from "./documentation-v2";
import { nullishToOptional } from "../../../helpers";

export const DocumentationPageDataV2 = z.object({
  configuration: nullishToOptional(DocumentationItemConfigurationV2),
});
